// format warranty to 99,999 pattern
export const warrantyFormatter = (warranty: string) => {
  return warranty ? warranty.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : warranty;
};
